import { makeStyles } from 'tss-react/mui';

const name = 'GRPCEndpoint';

export const useGRPCEndpointStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(7),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
  },
  record: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flex: '1 0 0',

    minWidth: 0,
  },
}));
